import { NavigateOptions } from "react-router-dom";
import { router } from "../routes";
import moment from "moment";

export function classNames(...classes: (string | boolean)[]) {
  return classes.filter(Boolean).join(" ");
}

export function navigateTo(props: string = "", options: NavigateOptions = {}) {
  return router.navigate(props?.[0] === "/" ? props : `/${props}`, options);
}

export function checkAllKeysHaveValue(obj, excludeValues = []) {
  if (Array.isArray(obj)) {
    return (
      obj.length > 0 &&
      obj.every((item) => checkAllKeysHaveValue(item, excludeValues))
    );
  } else if (typeof obj === "object" && obj !== null) {
    return Object.values(obj).every((value) =>
      checkAllKeysHaveValue(value, excludeValues)
    );
  } else {
    obj ??= "";
    return obj.toString().length > 0;
  }
}

export const convertDate = (date) => {
  return date ? moment(date).format("YYYY-MM-DD") : null;
};

export const setCookie = (name: string, value: string, days: number = 1) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

export const getCookie = (name: string) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const getUniqueId = () => {
  let uniqueId = getCookie("ace2_unique_id");
  if (!uniqueId) {
    uniqueId =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
    setCookie("ace2_unique_id", uniqueId, 1);
  }
  return uniqueId;
};
